import React from "react";
import ManageSignoff from "../checkin/ManageSignoff";

export default function ClientPortalSignoffModal({
  open,
  clientRow,
  accountId,
  onClose,
  onComplete,
}) {
  if (!open || !clientRow) return null;

  const portalClient = {
    ...clientRow,
    accountId: accountId ? Number(accountId) : null,
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 p-4"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="bg-white rounded-lg shadow-xl overflow-hidden flex flex-col w-full max-w-5xl max-h-[92vh]"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Timesheet sign-off"
      >
        <ManageSignoff
          key={clientRow.clientId}
          portalMode
          portalClient={portalClient}
          onPortalClose={onClose}
          onPortalComplete={onComplete}
        />
      </div>
    </div>
  );
}
